import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { Button, renderField } from '../../../helpers';

function UpdatePasswordForm({ isLoading, successMessage, errorMessage, handleSubmit, onSubmit }) {
  return (
    <form className="floating-labels m-t-40" onSubmit={handleSubmit(user => onSubmit(user))}>
      {successMessage ? (
        <div className="alert alert-success">
          {successMessage}
        </div>
      ) : null}

      <Field
        material
        required
        className="form-control"
        name="username"
        label="Email"
        component={renderField}
      />
      <Field
        material
        required
        className="form-control"
        name="password"
        type="password"
        label="Password"
        component={renderField}
      />
      <Field
        material
        required
        className="form-control"
        name="passwordConfirmation"
        type="password"
        label="Confirm Password"
        component={renderField}
      />

      {errorMessage ? (
        <div className="alert alert-danger">
          {errorMessage}
        </div>
      ) : null}

      <div className="form-group text-center m-t-20">
        <div className="col-xs-12">
          <Button
            submit
            disabled={isLoading}
            className="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
          >
            {isLoading ? 'Processing...' : 'Update Password'}
          </Button>
        </div>
      </div>
    </form>
  );
}

UpdatePasswordForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

UpdatePasswordForm.defaultProps = {
  successMessage: null,
  errorMessage: null
};

function validate({ username, password, passwordConfirmation }) {
  const errors = {};

  if (!username) {
    errors.username = 'Please enter a username';
  }

  if (!password) {
    errors.password = 'Please enter a password';
  }

  if (!passwordConfirmation) {
    errors.passwordConfirmation = 'Please enter a password confirmation';
  }

  if (password !== passwordConfirmation) {
    errors.password = 'Passwords must match';
  }

  return errors;
}

export default reduxForm({ form: 'update-password', validate })(UpdatePasswordForm);
